import React from 'react';

import { buildUpgradeUrl } from '@zapier/checkout';
import { useLink } from '@zapier/common-hooks';

import { Interval } from '@zapier/upsells/src/types';

import { UpgradeButton } from '../UpgradeButton';

export const UpgradeButtonToPricingPage = ({
  currentPlanInterval,
  currentPlanName,
  destinationPlanName,
  onClick,
}: {
  currentPlanInterval: Interval;
  currentPlanName: string;
  destinationPlanName: string;
  onClick?: () => void;
}) => {
  const { routeTo } = useLink();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    if (routeTo) {
      const url = buildUpgradeUrl(
        currentPlanName,
        destinationPlanName,
        currentPlanInterval
      );

      if (url) {
        routeTo(url);
      }
    }
  };

  return <UpgradeButton onClick={handleClick} />;
};
